import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { map, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SectorsService {

	qpFilterReset = new Subject<any>();
	constructor(private apiService: ApiService) { }

	getSectors(forFeeBased?, data?) {
		const sectorsURL = environment.sqaServiceUrl + `/api/sqa/sectors?forFeeBased=${forFeeBased}
		&isAddSector=${data && data.isAddSector ? data.isAddSector : false}
		&schemeId=${data && data.schemeId ? data.schemeId : ''}
		&tpId=${data && data.tpId ? data.tpId : ''}`;
		return this.apiService.get(sectorsURL);
	}

	getSectorForSelect(value?: any, data?) {
		return this.getSectors(value, data).pipe(map(sectors =>
			sectors.map(sector => ({
				name: sector.sector,
				value: sector
			}))
		));
	}
	getSubSectors(sectorID) {
		const subSectorsURL = `${environment.sqaServiceUrl
			}/api/sqa/sectors/subsectors/${sectorID}`;
		return this.apiService.get(subSectorsURL);
	}
	getConfig(type) {
		const configUrl = `${environment.ToTServiceURL
			}/api/tot-toa/v1/batch/config`
		return this.apiService.get(configUrl, {
			type
		})
	}
	// tslint:disable-next-line:no-shadowed-variable
	getJobRoles(sectorID, subSectorID?: string, mappingType?: string, expoCode?: string, expoVersion?: string, qpCode?:string, qpVerison?: string, isDomain?: boolean, isPwD?: boolean) {
		// tslint:disable-next-line:max-line-length
		var ignoreStatus = false;
		if (subSectorID === 'ignoreStatus') {
			ignoreStatus = true
			subSectorID = '';
		}
		const params: any = {
			sectorID,
			subSectorID: subSectorID || '',
			sdisqps: false,
			mappingType: mappingType,
			ignoreStatus: ignoreStatus,
			expoCode: expoCode,
			expoVersion: expoVersion,
			qpCode: qpCode,
			qpVerison: qpVerison,
			isDomain: isDomain ? isDomain : "",
			isPwD: isPwD ? isPwD : "",
			// tslint:disable-next-line:max-line-length
			fields: `qpCode,nsqfLevel,qpParamOne,jobRole,jobRoleDesc,eqptDetails,version,sectors,jobRoleDesc,minEduQual,minJobEntryAge,isBorrowed,expository,propAssmtCertPlan,status`
		};
		const subSectorsURL = `${environment.sqaServiceUrl
			}/api/sqa/qp/getbysector`;
		return this.apiService.get(subSectorsURL, params)
			.pipe(map(jobRoles => {
				console.log(jobRoles)
				jobRoles.data = jobRoles.data || []
				jobRoles.data.map(jobRole => {
					// jobRole.minEduQual =
					const minEduQual = []
					jobRole.minEduQual = jobRole.minEduQual || []
					jobRole.minEduQual.map(eq => {
						if (eq.minEduQualDesc) {
							minEduQual.push(eq)
							return;
						}
						eq.eduQual = eq.eduQual || [];
						eq.eduQual.map(e => {
							minEduQual.push(e)
						})
					})
					jobRole.minEduQual = minEduQual
				})
				return jobRoles;
			}));
	}

	getJobRolesWithSelectedFields(fields: string, sectorID, subSectorID?: string) {
		// tslint:disable-next-line:max-line-length
		const params: any = {
			sectorID,
			subSectorID: subSectorID || '',
			sdisqps: false,
			fields: fields
		};
		const subSectorsURL = `${environment.sqaServiceUrl
			}/api/sqa/qp/getbysector`;
		return this.apiService.get(subSectorsURL, params)
			.pipe(map(jobRoles => {
				console.log(jobRoles)
				jobRoles.data = jobRoles.data || []
				jobRoles.data.map(jobRole => {
					// jobRole.minEduQual =
					const minEduQual = []
					jobRole.minEduQual = jobRole.minEduQual || []
					jobRole.minEduQual.map(eq => {
						if (eq.minEduQualDesc) {
							minEduQual.push(eq)
							return;
						}
						eq.eduQual = eq.eduQual || [];
						eq.eduQual.map(e => {
							minEduQual.push(e)
						})
					})
					jobRole.minEduQual = minEduQual
				})
				return jobRoles;
			}))
	}

	getPlatFromJobRoles(sectorID, subSectorID?: string) {
		// tslint:disable-next-line:max-line-length
		const pageNo = 1, size = 10;
		const keyword = '';
		// let sectorID: sectorID;
		const search = sectorID;
		// const search = ;
		const params = {
			keyword,
			search,
			// sectorID,
			// subSectorID: subSectorID || '',
			pageNo,
			size,
			fields: `qpCode,nsqfLevel,qpParamOne,jobRole,jobRoleDesc,eqptDetails,version,sectors,minEduQual,minJobEntryAge,jobRoleDesc`
		};
		const subSectorsURL = `${environment.sqaServiceUrl
			}/api/sqa/qp/search`;
		return this.apiService.get(subSectorsURL, params);
	}
	getJobRolesForSelect(sectorID, subSectorID?: string, mappingType?: string, expoCode?: string, expoVersion?: string, qpCode?: string, qpVerison?: string) {
		return this.getJobRoles(sectorID, subSectorID, mappingType, expoCode, expoVersion, qpCode, qpVerison).pipe(map(res => {
			if (res && res.data) {
				return res.data.map(data => {
					return {
						// tslint:disable-next-line:max-line-length
						Changedname: `${data.jobRole}(Code: ${data.qpCode},
							Version: ${data.version}
								${data.isBorrowed ? ',' : ''} ${data.isBorrowed ? 'Borrowed' : ''})
								${data.expository && data.expository.length > 0 ? ',' + data.expository[0].expoName : ''}`,
						name: data.jobRole,
						value: data.jobRole,
						data: data
					};
				});
			}
			return [];
		}));
	}

	getJobRolesForCourse(sectorID, subSectorID?: string, mappingType?: string) {
		return this.getJobRoles(sectorID, subSectorID, mappingType).pipe(map(res => {
			if (res && res.data) {
				return res.data.map(data => {
					return {
						// tslint:disable-next-line:max-line-length
						Changedname: `${data.jobRole}(Code: ${data.qpCode}, Version: ${data.version}
						${data.isBorrowed ? ',' : ''} ${data.isBorrowed ? 'Borrowed' : ''})
						${data.expository && data.expository.length > 0 ? ',' + data.expository[0].expoName : ''}`,
						name: data.jobRole,
						value: {
							jobRole: data.jobRole,
							qpCode: data.qpCode,
							version: data.version,
							expoCode: data.expository && data.expository.length > 0 ? data.expository[0].expoCode : '',
						},
						data: data
					};
				});
			}
			return [];
		}));
	}

	getSscDetails(sectorId) {
		const url = `${environment.userServiceUrl}/api/user/v1/ssc/${sectorId}`;
		return this.apiService.get(url);
	}

	getAllSSc() {
		const url = `${environment.userServiceUrl}/api/user/v1/ssc`;
		return this.apiService.get(url);
	}

	getNsqfLevel() {
		const url = `${environment.sqaServiceUrl}/api/sqa/nos/nsqflevel`;
		return this.apiService.get(url);
	}


	createGrading(id, data) {
		const url = `${environment.schemeServiceURL}/api/v1/schemeModule/scheme/gradingMatrix/${id}`;
		return this.apiService.post(url, data);
	}

	createGradingIfFalse(id, matrixId, data) {
		const url = `${environment.schemeServiceURL}/api/v1/schemeModule/scheme/gradingMatrix/${id}/${matrixId}`;
		return this.apiService.patch(url, data);
	}

	getNsqfLevelForSelect() {
		const url = `${environment.sqaServiceUrl}/api/sqa/nos/nsqflevel`;
		return this.apiService.get(url).pipe(map(res => {
			if (res && res.data) {
				return res.data.map(d => {
					return {
						name: d.nsqflevel,
						value: d.nsqflevel
					};
				});
			}
			return [];
		}));

	}
	getSectorsWithOutAuth() {
		const sectorsURL = environment.sqaServiceUrl + '/api/sqa/sectors/v1';
		return this.apiService.get(sectorsURL);
	}
	getSubSectorsWithoutAuth(sectorID) {
		const subSectorsURL = `${environment.sqaServiceUrl
			}/api/sqa/sectors/subsectors/v1/${sectorID}`;
		return this.apiService.get(subSectorsURL);
	}
	getJobRolesWithoutAuth(sectorID, subSectorID?: string) {
		const params: any = {
			sectorID,
			subSectorID: subSectorID || '',
			fields: `qpCode,nsqfLevel,qpParamOne,jobRole,jobRoleDesc,version,sectors`
		};
		const subSectorsURL = `${environment.sqaServiceUrl
			}/api/sqa/qp/getbysector/v1`;
		return this.apiService.get(subSectorsURL, params)
			.pipe(map(jobRoles => {
				console.log(jobRoles)
				jobRoles.data = jobRoles.data || []
				jobRoles.data.map(jobRole => {
					// jobRole.minEduQual =
					const minEduQual = []
					jobRole.minEduQual = jobRole.minEduQual || []
					jobRole.minEduQual.map(eq => {
						if (eq.minEduQualDesc) {
							minEduQual.push(eq)
							return;
						}
						eq.eduQual = eq.eduQual || [];
						eq.eduQual.map(e => {
							minEduQual.push(e)
						})
					})
					jobRole.minEduQual = minEduQual
				})
				return jobRoles;
			}))
	}

	getEduQualification() {
		const eduQualURL = environment.nsdcCommonServiceUrl + '/api/nsdccommon/educationalqualifications';
		return this.apiService.get(eduQualURL);
	}

	getExpReq() {
		const expReqURL = environment.nsdcCommonServiceUrl + '/api/nsdccommon/experiencerequired';
		return this.apiService.get(expReqURL);
	}

	getSectorsByTpId(tpId, pageNo, perPage, schemeId) {
		// tslint:disable-next-line: max-line-length
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/FeeBasedScheme/GetSectors?query=tpId:${tpId},schemeId:${schemeId}&pageNo=${pageNo}&limit=${perPage}&pagination=yes`;
		return this.apiService.get(url);
	}

	getCoursesByTpId(tpId, pageNo, perPage, schemeId) {
		// tslint:disable-next-line: max-line-length
		const url = `${environment.userServiceUrl}/api/user/v1/trainingpartner/FeeBasedScheme/GetCourses/v2?query=tpId:${tpId},schemeId:${schemeId}&pageNo=${pageNo}&limit=${perPage}&pagination=yes`;
		return this.apiService.get(url);
	}

	getHomepageSectors() {
		const sectorsURL = environment.sqaServiceUrl + '/api/sqa/sectors/v1';
		return this.apiService.get(sectorsURL);
	}

	getHomepageSubSectors(sectorID) {
		const subSectorsURL = `${environment.sqaServiceUrl
			}/api/sqa/sectors/subsectors/v1/${sectorID}`;
		return this.apiService.get(subSectorsURL);
	}

	getSectorsForPublic() {
		const URL = `${environment.sqaServiceUrl}/api/sqa/public/sectors`;
		return this.apiService.get(URL);
	}

	getExpoVersionPublic() {
		const URL = `${environment.sqaServiceUrl}/api/sqa/get/public/expositories`;
		return this.apiService.get(URL);
	}

	getModelCurriculumFile(qpData) {
		const URL = `${environment.sqaServiceUrl}/api/sqa/sectors/model/curriculum/file?qpCode=${qpData.qpCode}&version=${qpData.version}`
		return this.apiService.get(URL);
	}

	getModelCurriculumFileForNOS(nosData) {
		const URL = `${environment.sqaServiceUrl}/api/sqa/nos/model/curriculum/file?unitCode=${nosData.unitCode}&version=${nosData.version}`
		return this.apiService.get(URL);
	}

	checkMicrocredentialInstances(payload) {
		const URL = `${environment.sqaServiceUrl}/api/sqa/microcredential/instances`;
		return this.apiService.post(URL, payload);
	}
}
